import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { propShape, propMatch } from '@/helpers/custom-prop-types';
const ProffitSearchFolderHoc = () => (ChildComponent) => {
    const ProffitSearchFolderHocInner = (props) => {
        const { match: { params: { id }, }, proffitSearch, } = props;
        const folder = useMemo(() => (proffitSearch.folders || []).find((v) => v.id === id), [proffitSearch, id]);
        if (!folder) {
            return _jsx(CustomRedirect, { to: '/mypage' });
        }
        return (_jsx(ChildComponent, Object.assign({}, props, { folder: folder, proffitSearch: proffitSearch })));
    };
    ProffitSearchFolderHocInner.propTypes = {
        match: propMatch(),
        proffitSearch: propShape().isRequired,
    };
    return ProffitSearchFolderHocInner;
};
export default ProffitSearchFolderHoc;
